import React, { lazy, Suspense } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import routeConfig from "configs/RouteConfig";
import FormattingService from "services/FormattingService";
import { intersection } from "lodash";

function isArrayWithLength(arr) {
	return Array.isArray(arr) && arr.length;
}

function getAllowedRoutes() {
	const roles = [];
	const payload = FormattingService.parseJwt();
	if (payload) {
		roles.push(1);
	}
	return routeConfig.filter(({ permission }) => {
		if (!permission) return true;
		else if (!isArrayWithLength(permission)) return true;
		else return intersection(permission, roles).length;
	});
}

export const AppViews = () => {
	const routes = getAllowedRoutes();
	return (
		<Suspense fallback={<Loading cover="content" />}>
			<Switch>
				{routes?.map((route) => {
					const { key, path, component, permission, ...rest } = route;
					return (
						<Route
							{...rest}
							key={key}
							path={path}
							component={lazy(() => import(`${component}`))}
						></Route>
					);
				})}
				<Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/list`} />
			</Switch>
		</Suspense>
	);
	// return (
	//   <Suspense fallback={<Loading cover="content"/>}>
	//     <Switch>
	//       <Route exact path={`${APP_PREFIX_PATH}/Groups`} component={lazy(() => import(`./Locks/LocksGroup`))} />
	//       <Route path={`${APP_PREFIX_PATH}/Groups/:id/ChildLockGroup`} component={lazy(() => import(`./Locks/LocksGroup`))} />
	//       <Route path={`${APP_PREFIX_PATH}/Groups/:group/:id/:tab`} component={lazy(() => import(`./Locks/LockGroupChange`))} />
	//       <Route exact path={`${APP_PREFIX_PATH}/Locks`} component={lazy(() => import(`./Locks/AllLocks`))} />
	//       <Route path={`${APP_PREFIX_PATH}/Locks/:lock/:id/:tab`} component={lazy(() => import(`./Locks/LockChange`))} />
	//       <Route path={`${APP_PREFIX_PATH}/Dashboard`} component={lazy(() => import(`./Dashboard/index`))} />
	//       <Route exact path={`${APP_PREFIX_PATH}/AllUsers`} component={lazy(() => import(`./Users/AllUsers`))} />
	//       <Route path={`${APP_PREFIX_PATH}/AllUsers/:user/:id/:tab`} component={lazy(() => import(`./Users/UserChange`))} />
	//       <Route exact path={`${APP_PREFIX_PATH}/UsersGroup`} component={lazy(() => import(`./Users/UsersGroup`))} />
	//       <Route path={`${APP_PREFIX_PATH}/UsersGroup/:group/:id`} component={lazy(() => import(`./Users/UserGroupMember`))} />
	//       <Route path={`${APP_PREFIX_PATH}/Sync`} component={lazy(() => import(`./Sync/Sync`))} />
	//       <Route path={`${APP_PREFIX_PATH}/SettingsApp`} component={lazy(() => import(`./Settings/AppSettings`))} />
	//       <Route path={`${APP_PREFIX_PATH}/SettingsAccount`} component={lazy(() => import(`./Settings/AccSettings`))} />
	//       <Route path={`${APP_PREFIX_PATH}/Admin`} component={lazy(() => import(`./Settings/AdminSet`))} />
	//       <Redirect from={`${APP_PREFIX_PATH}`} to={`${APP_PREFIX_PATH}/Dashboard`} />
	//     </Switch>
	//   </Suspense>
	// )
};

export default React.memo(AppViews);
